











































import { Component, Vue } from 'vue-property-decorator';
import { ISignInCommand } from '@/connectors/identity/identity.model';
import MpLoginInput from '@/components/controls/mp-login-input/MpLoginInput.vue';
@Component({
  components: { MpLoginInput }
})
export default class Login extends Vue {
  warningMessage: string | null = null;
  isPasswordVisible: boolean = false;

  loading: boolean = false;
  signIn: ISignInCommand = {
    username: '',
    password: ''
  };

  $refs!: {
    form: HTMLFormElement;
  };

  async login() {
    this.warningMessage = null;
    if (!this.signIn.username) {
      this.warningMessage = 'Bitte geben Sie Ihren Benutzernamen an.';
      return;
    }

    if (!this.signIn.password) {
      this.warningMessage = 'Bitte geben Sie Ihr Passwort an.';
      return;
    }

    this.loading = true;

    try {
      const success = await this.$store.dispatch('user/login', this.signIn);

      if (success) {
        await this.$router.push('/');
      }
    } catch (e) {
      const status = e.response.status;
      let alertMessage = '';
      switch (status) {
        case 404:
          alertMessage = 'Ihre Zugangsdaten sind ungültig.';
          break;
        case 401:
          alertMessage = 'Ihre Zugangsdaten sind ungültig.';
          break;
        case 403:
          alertMessage = 'Ihre Zugangsdaten sind ungültig.';
          break;
        default:
          alertMessage =
            'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder wenden Sie sich an den Support.';
          break;
      }

      this.warningMessage = alertMessage;
    } finally {
      this.loading = false;
    }
  }
}
